import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-primary" }, "Tere tulemast Kriminaalhooldusportaali!", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Olete sisenenud Kriminaalhooldusportaali. Portaali eesmärgiks on koondada Teile vajalik info virtuaalse toimikuna, et toetada Teie kriminaalhoolduse läbimist. Siin lehel hakkate edaspidi nägema kogu Teie kriminaalhooldusega seonduvat informatsiooni ja dokumente. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Virtuaalse toimiku sisu avaneb Teile peale seda, kui olete kohtunud oma kriminaalhooldusametnikuga ning andnud nõusoleku Kriminaalhooldusportaali kasutamiseks. Peale seda saate infoga tutvuda Teile sobival ajal. ", -1)
const _hoisted_4 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_KRHPTyhiPaigutus = _resolveComponent("KRHPTyhiPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPTyhiPaigutus, { portaaliPealkiri: "Tere tulemast Kriminaalhooldusportaali!" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-2" }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.logiValja,
                      size: "large",
                      color: "light-blue-darken-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Logi välja")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}